/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Assistant_Agent_Credits_LeftInputs */



/**
* | output |
* | --- |
* | "{count} credits left" |
*
* @param {Assistant_Agent_Credits_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_agent_credits_left = /** @type {((inputs: Assistant_Agent_Credits_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Agent_Credits_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} crédits restants`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Credits verbleibend`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} crediti rimanenti`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Осталось кредитов ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Créditos restantes de ${i?.count}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`剩余 ${i?.count} 学分`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`残りクレジット数：${i?.count}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} क्रेडिट शेष`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} créditos restantes`)
	return /** @type {LocalizedString} */ (`${i?.count} credits left`)
});